import type { SportEventModule } from '../types';
import { parseNhlEvent } from './parser';
import { describeNhlEvent } from './descriptions';
import { NHL_EVENT_TYPES } from './eventTypes';
import { NHL_STATS } from './stats';
import { nhlFeaturedParticipantIds } from './featured';

export const NHL_SPORT_MODULE: SportEventModule = {
  id: 'NHL',
  displayName: 'NHL',
  objectOfPlayLabel: 'Puck',
  parseEvent: parseNhlEvent,
  describeEvent: describeNhlEvent,
  eventTypes: NHL_EVENT_TYPES,
  stats: NHL_STATS,
  featuredParticipantIds: nhlFeaturedParticipantIds,
};
